import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch} from "vue";
import CollapsableCard from "@/components/bootstrap/CollapsableCard.vue";
import { useTranslations } from "@/hooks/useTranslations";
import VIngredientsDisplayNames from "@/components/vIngredientsDisplayNames.vue";
import VUSContainsPercentOfForm from "@/components/vUSContainsPercentOfForm.vue";
import VToggleSwitch from "@/components/vToggleSwitch.vue";
import {Recipe} from "@/models/Recipes/Recipe";
import IngredientDisplay from "@/models/Ingredient/IngredientDisplay";
import {LabelIngredientConfiguration} from "@/models/NutritionLabels/v2/LabelIngredientConfiguration";


export default /*#__PURE__*/_defineComponent({
  __name: 'IngredientConfiguration',
  props: {
    model: null,
    language: null,
    recipe: null,
    ingredientAndSubRecipeDisplays: null,
    subRecipeDisplays: null,
    getChangedDisplayNames: null,
    showAiDetector: { type: Boolean },
    aiAnalysisApplied: { type: Boolean },
    isApplyingAiAllergens: { type: Boolean },
    isTrialUser: { type: Boolean }
  },
  emits: [
  "fetch-preview",
  "toggle-subrecipes",
  "reset-ingredient-display",
  "reset-subrecipe-display",
  "update:model",
  "apply-ai-allergens",
],
  setup(__props: any, { emit }) {

const props = __props as {
  model: LabelIngredientConfiguration;
  language: string;
  recipe: Recipe;
  ingredientAndSubRecipeDisplays: IngredientDisplay[];
  subRecipeDisplays: IngredientDisplay[];
  getChangedDisplayNames: any;
  showAiDetector?: boolean;
  aiAnalysisApplied?: boolean;
  isApplyingAiAllergens?: boolean;
  isTrialUser?: boolean;
};





const translations = useTranslations();
const localModel = ref({ ...props.model });
const hasAiAnalysisAppliedState = computed(() => Boolean(!props.isTrialUser && (
  props.aiAnalysisApplied
  || props.ingredientAndSubRecipeDisplays?.some((ingredient) =>
    ingredient.allergenVisualState && ingredient.allergenVisualState !== "default"
  )
)));
const showAiAllergenPrompt = computed(() =>
  Boolean(props.showAiDetector)
);
const aiPromptStateClass = computed(() =>
  hasAiAnalysisAppliedState.value
    ? "allergen-ai-detector-prompt--clear"
    : ""
);
const aiPromptMascotState = computed(() => {
  if (props.isApplyingAiAllergens) {
    return "analyzing";
  }

  if (hasAiAnalysisAppliedState.value) {
    return "ready";
  }

  return "idle";
});
const aiPromptTitle = computed(() =>
  hasAiAnalysisAppliedState.value
    ? "AI allergens already applied"
    : "Apply AI Allergens"
);
const aiPromptDescription = computed(() => {
  if (hasAiAnalysisAppliedState.value) {
    return "AI allergens are already in place. If you need to run them again, go back to the recipe allergen section.";
  }

  return "To apply AI allergens, go back to the recipe allergen section.";
});

// Emit updates
watch(
  localModel,
  (val) => {
    emit("update:model", val);
  },
  { deep: true }
);

// Emit events for actions
function emitFetchPreview() {
  emit("fetch-preview");
}

function emitToggleSubrecipes() {
  emit("toggle-subrecipes");
}

function emitResetIngredientDisplay() {
  emit("reset-ingredient-display");
}

function emitResetSubrecipeDisplay() {
  emit("reset-subrecipe-display");
}

return { __sfc: true,props, emit, translations, localModel, hasAiAnalysisAppliedState, showAiAllergenPrompt, aiPromptStateClass, aiPromptMascotState, aiPromptTitle, aiPromptDescription, emitFetchPreview, emitToggleSubrecipes, emitResetIngredientDisplay, emitResetSubrecipeDisplay, CollapsableCard, VIngredientsDisplayNames, VUSContainsPercentOfForm, VToggleSwitch }
}

})